import CheckoutPageLayout from './CheckoutPageLayout';
import CheckoutSuccessImage from '../images/checkout-success.svg';
import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';

interface CheckoutSuccessPageProps {
  onViewInvoice: () => void;
}

const CheckoutSuccessPage = ({ onViewInvoice }: CheckoutSuccessPageProps) => {
  return (
    <CheckoutPageLayout>
      <div className="flex flex-1 flex-col items-center justify-center">
        <img
          src={CheckoutSuccessImage}
          alt="Checkout Success"
          className="w-[103px] h-auto mb-4"
        />

        <div className="flex flex-col gap-1 text-center mb-8">
          <Text variant="smallSubheader" className="text-black">
            Congratulations! Your order has been placed
          </Text>
          <Text variant="body" className="text-gray-600">
            We’ll send you an email to confirm your order details.
          </Text>
        </div>

        <Button variant="primary" size="medium" onPress={onViewInvoice}>
          View Invoice
        </Button>
      </div>
    </CheckoutPageLayout>
  );
};

export default CheckoutSuccessPage;
